import { useState, useEffect } from 'react';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import UseAxios from '../../../Api/http/http';
import { MAP_EDIT_USER_RESPONSE_MSG } from '../../../Constants/strings';
import { roleList } from '../../../Api/request/role';
import { dealRoleList } from '../../../Api/request/roleMaster';

const useRoles = () => {
  const [rolesOption, setRolesOption] = useState([]);
  const { snackbarOpen } = useSnackbar();

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        // Fetch roles from roleList API
        const response = await UseAxios(roleList());
        const roleListNames = response.data.roleDetails;
        const rolesDetails = roleListNames
          .filter((roles) => roles.isActive)
          .map((role) => ({
            id: role.portalRoleId,
            name: role.roleName,
          }));

        // Fetch DT roles from dealRoleList API
        const dealRoleListResponse = await UseAxios(dealRoleList());
        let dealRoles = dealRoleListResponse.data.roleDetails;
        dealRoles = dealRoles
          .filter((roles) => roles.isActive)
          .map((role) => ({
            id: role.portalRoleId,
            name: role.roleName,
          }));

        // Merge the roles from both APIs
        const mergedRoles = [...rolesDetails, ...dealRoles];
        setRolesOption(mergedRoles);
      } catch (error) {
        snackbarOpen(MAP_EDIT_USER_RESPONSE_MSG.OOPS_TRY_AGAIN, 'warning');
        console.error(error);
      }
    };

    fetchRoles();
  }, [snackbarOpen]);

  return { rolesOption, setRolesOption };
};

export default useRoles;
